// <- TaskManagment.js
import React, { useState, Fragment, useEffect } from "react";
import { Button, ListGroup, ListGroupItem } from "reactstrap";
import TableWithSortPagtn from "../../common/TableWithSortPagtnWithTotSummary";
import DropDownActions from "../../common/DropDownActions";
import moment from 'moment';
import api from "../../../apis/api";
import Notifications from "../../../components/common/Notifications";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";

const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let sumhours = 0;
let sumbillable = 0;
let estimated = 0;
let maxwidth = "80vw";
const ListPLEncashReport = React.memo(
  ({
    handleAddEditTaskForm,
    handleSelectedTask,
    handleOpenCalendar,
    handleDelTask,
    empTask,
    taskProjectInfo,
    handleToggleAllTaskCalendar,
    getAllTaskOfEmployee,
    handleUnlockRequestForm,
    handlereload,
    disablePagination
  }) => {
    const [thead] = useState([
      "Id",
      "Date",
      "Project",
      "Employee",
      "Task",
      "Description",
      "Hours Spent",
      "Hours Billable",
      //  "Leave Type",
      "Duty Type",
      "Task Status",
      "Status"

    ]);
    const [trow, setTrow] = useState([]);
    const [activeTask, setActiveTask] = useState(0);
    const [curstatus, setcurstatus] = useState(0);
    const [curstatusList, setcurstatusList] = useState([]);
    const [reason, setreason] = useState("");
    const [error, setError] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [selectedEmployeesString, setSelectedEmployeesString] = useState([]);
    const DarkBackground = styled.div`
   display: none; /* Hidden by default */
     position: fixed; /* Stay in place */
     z-index: 999; /* Sit on top */
     left: 0;
     top: 0;
     width: 100%; /* Full width */
     height: 100%; /* Full height */
     overflow: auto; /* Enable scroll if needed */
     background-color: rgb(0, 0, 0); /* Fallback color */
     background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
   ${(props) =>
        props.disappear &&
        css`
       display: block; /* show */
     `}
   `;
    const handleOnclickSelectedTask = React.useCallback(
      (task, i) => {
        setActiveTask(i);
        handleSelectedTask(task);
      },
      [handleSelectedTask]
    );



    const DelTask = React.useCallback(
      (delId) => {
        handleDelTask(delId);
      }, [empTask]);


    const chunkSize = 40;
    const breakStringIntoChunks = (str, chunkSize) => {
      const chunks = [];
      for (let i = 0; i < str.length; i += chunkSize) {
        chunks.push(str.substring(i, i + chunkSize));
      }
      return chunks;
    };
    useEffect(() => {
      sumhours = 0;
      sumbillable = 0;
      estimated = 0;
      const seenTaskIds = new Set();
      empTask.map((el) => {
        sumhours += el.hoursSpent || 0;
        sumbillable += el.hoursBillable || 0;
        //sumhours =el.approvedStatus==0 && el.approvedId == 0 ? sumhours+el.hoursSpent : sumhours;
        //sumbillable =el.approvedStatus==0 && el.approvedId == 0 ? sumbillable+el.hoursBillable : sumbillable;
        // estimated=el.approvedStatus==0 && el.approvedId == 0 ? estimated+el.estimatedHour : estimated;
        if (!seenTaskIds.has(el.employeeTimeSheetId)) {
          estimated += el.estimatedHour || 0;
          seenTaskIds.add(el.employeeTimeSheetId);
        }
      });
      let trow = empTask.map((el) => ({
        Id: <div style={{ width: '0px' }}>{el.timesheetStatusId}</div>,
        rawId: el.timesheetStatusId,       // ✅ raw timesheet ID
        employeeId: el.employeeID,
        Date: <div style={{ width: '100px' }}>{moment(el.workDate).format('DD-MM-YYYY')}</div>,
        Project: <div style={{ width: '100px' }}>{el.projectName === null ? "" : el.projectName}</div>,
        Employee: (
          <div style={{ width: '140px' }}><h2 className="table-avatar">

            <span className="ml-2">
              <span style={{ fontWeight: "400", color: "black" }}>
                {el.employeeName}
              </span>
              {/* <span> {el.empDesignation}</span> */}
            </span>
          </h2></div>
        ),
        Task: <div style={{ width: '100px' }}>{el.issueTitle === null ? "" : el.issueTitle}</div>,
        Description: el.description === null ? "" : (breakStringIntoChunks(el.description, chunkSize).map((chunk, chunkIndex) => (
          <div key={chunkIndex} style={{ width: '260px' }}>{chunk}</div>))),
        // "Estimated Hours":<div style={{width:'50px'}}>{el.estimatedHour}</div>,
        "Hours Spent": <div style={{ width: '120px' }}>{el.hoursSpent === null ? "" : el.hoursSpent}</div>,
        "Hours Billable": <div style={{ width: '120px' }}>{el.hoursBillable === null ? "" : el.hoursBillable}</div>,
        "Duty Type": el.dutyType === null ? "" :(breakStringIntoChunks(el.dutyType, 14).map((chunk, chunkIndex) => (
          <div key={chunkIndex} style={{ width: '120px' }}>{chunk}</div>))) ,
        // "Leave Type": <div>{el.leaveType==1 ? "Half Day":(el.leaveType==2 ? "Full Day" : "Full Day")}</div>,
        "approvedStatusRaw": el.approvedStatus,
        "approvedStatusIdRaw": el.approvedId,
        "approvedStatusIdR": el.approvedStatus == 1 ? "Approved" : (el.approvedStatus == 0 && el.approvedId == 0 ? "Pending" : "Rejected"),
        "Task Status": <div style={{ width: '100px' }}>{el.timeSheetStatus == 1 ? "New" : (el.timeSheetStatus == 2 ? "In Progress" : "Completed")}</div>,
        "Status": <div style={{ width: '100px' }}>{el.approvedStatus == 1 ? "Approved" : (el.approvedStatus == 0 && el.approvedId == 0 ? "Pending" : "Rejected")}</div>,


        // requester: <span style={{ fontSize: "12px " }}>{el.employeeName}</span>,
        // action: (
        //   <DropDownActions
        //     dropDownOption={[
        //       {
        //         action: "Edit",
        //         handleAction: () => handleClickTicket(el),
        //       },
        //       {
        //         action: "View",
        //         handleAction: () => handleClickDelete(el.ticketId),
        //       },
        //     ]}
        //   ></DropDownActions>
        // ),
        // requester: el.requesters.map((el) => (
        //   <span style={{ fontSize: "12px " }}>{el.employeeName},</span>
        // )),
      }));

      setTrow(trow);
    }, []);
    const onchangeApprovestatus = React.useCallback((val) => {
      // let formData = {};
      // const ids = empTask.map(user => user.timesheetStatusId);
      // const joinedString=ids.join(',');
      // formData = {

      //   employeeTimeSheetIdList:joinedString,
      //   approvedStatus:true,
      //   approvedId:parseInt(loginUser.EmployeeId),        
      //   reason:""
      // };
      // await api.task().ApproveTaskStatus(formData);
      setcurstatus(val);
      setcurstatusList({ value: val, label: val == 1 ? "Approve" : "Rejected" })
    }, [setcurstatus, setcurstatusList]);
    const handleChange = (reason) => {
      setreason(reason.target.value);
    }
    const handleSubmit = React.useCallback(async () => {
      setLoaded(true);
      let formData = {};
      const ids = empTask.map(user => user.timesheetStatusId);
      const joinedString = ids.join(',');
      formData = {

        employeeTimeSheetIdList: selectedEmployeesString,
        approvedStatus: curstatus == 1 ? true : false,
        approvedId: parseInt(loginUser.EmployeeId),
        reason: reason
      };

      if (curstatus == 1) {
        setcurstatusList([]);
        setreason("");
        setcurstatus(0);
        await api.task().ApproveTaskStatus(formData);
        setError({ ...error, message: "Work Status Approved Successfully..", status: 200 });
        // setError({ ...error, message: "Work Status Approved Successfully..", status: 200 });
      }
      else if (curstatus == 2) {
        if (reason != '') {
          setcurstatusList([]);
          setreason("");
          setcurstatus(0);
          await api.task().ApproveTaskStatus(formData);
          setError({ ...error, message: "Work Status Rejected Successfully..", status: 200 });
        }
        // setError({ ...error, message: "Work Status Rejected Successfully..", status: 200 });
      }
      else {
        setError({ ...error, message: "Choose approve/reject..", status: 500 });
      }
      handlereload(curstatus, reason);
      //  setTimeout(() => { 


      //   }, 3000);

    }, [setcurstatusList, setreason, setcurstatus, empTask, loginUser, curstatus, reason, selectedEmployeesString])
    const onSelectionChange = (selectedIds) => {
      setSelectedEmployees(selectedIds);
      const childrenValues = selectedIds.map(item => item.props.children).join(",");
      setSelectedEmployeesString(childrenValues);
    };
    return (
      <Fragment>
        <div className="fixed-header">
          <div>
            {/* <Button
              size="sm"
              outline
              className="secondary"
              onClick={() => handleAddEditTaskForm("add")}
            >
              Add Task
            </Button> */}
            &nbsp;

            <div className="d-inline float-right ">
              {/* <Button
              size="sm"
              outline
              className="secondary"
              onClick={handleUnlockRequestForm}
            >
              Request Unlock
            </Button> */}
              {/* <Button color="" onClick={handleOpenCalendar}>
                <i className="fas fa-calendar-day text-muted"></i>
              </Button> */}
              {/* <Button color="" onClick={handleToggleAllTaskCalendar}>
                <i className="fas fa-calendar-alt text-muted"></i>
              </Button> */}
            </div>
          </div>
        </div>
        <div className="" style={{ maxWidth: maxwidth, overflowY: disablePagination ? "visible !important" : "auto", maxHeight: disablePagination ? "auto !important" : "80vh" }}>
          <TableWithSortPagtn thead={thead} trow={trow} pageSize={10} sumhours={Math.round(sumhours * 100) / 100} sumbillable={sumbillable} estimated={Math.round(estimated * 100) / 100} onchangeApprovestatus={onchangeApprovestatus} curstatus={curstatus} handleSubmit={handleSubmit} handleChange={handleChange} curstatusList={curstatusList} onSelectionChange={onSelectionChange} loginUser={loginUser}></TableWithSortPagtn>
        </div>
        <Notifications notifications={error}></Notifications>
        <DarkBackground disappear={loaded}>
          <LoadingOverlay
            active={true}
            spinner={true}
            text="Loading your content..."
          >
          </LoadingOverlay>
        </DarkBackground>
        {/* <div className="mt-3">
          <ListGroup className="task-list ">
            {empTask.map((tasks, i) => (
              <ListGroupItem
                key={i}
                onClick={() => handleOnclickSelectedTask(tasks, i)}
                style={i === activeTask ? active : null}
              >
                <div className="task-container ">
                  <span className="task-check">
                  {tasks.timeSheetStatus ==3 ? (<i className="fas fa-check  project-task-icon" style={{ color: 'green'}}></i>) : <i className="fas fa-check  project-task-icon"></i>}
                    
                  </span>
                  <span className="task-label">{tasks.description}</span>
                  <span className="task-label">{tasks.hoursSpent}</span>
                  <span className="task-label">{tasks.timeSheetStatus}</span>
                  <span className="task-action-btn task-btn-right">
                    <span
                      className="action-circle large task-assign"
                      title="Assign"
                    >
                      <i className="fas fa-user  project-task-icon"></i>
                    </span>
                    <span
                      className="action-circle large delete-btn"
                      title="Delete Task"
                      onClick={() => DelTask(tasks.employeeTimeSheetId)}
                    >
                      <i className="fas fa-trash project-task-icon"></i>
                    </span>
                  </span>
                </div>
              </ListGroupItem>
            ))}
          </ListGroup>
        </div> */}
      </Fragment>
    );
  }
);

export default ListPLEncashReport;
